// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/lazy'

import VueAnalytics from 'vue-analytics'

// import 'ant-design-vue/dist/antd.min.css'
// import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import {
  Upload,
  Steps,
  Affix,
  Tooltip,
  BackTop,
  Checkbox,
  Collapse,
  Button,
  Icon,
  Form,
  Input,
  Alert,
  message,
  Layout,
  Dropdown,
  Avatar,
  Menu,
  Table,
  Card,
  Tag,
  Spin,
  Col,
  Row,
  Popconfirm,
  Switch,
  Popover,
  Select,
  InputNumber,
  DatePicker,
  Drawer,
  Divider,
  Modal,
  List,
  Radio,
  Badge,
  Descriptions,
  FormModel,
  Slider,
  Statistic
} from 'ant-design-vue'
import axios from 'axios'
import Vue2Editor from 'vue2-editor'
// import VueFriendlyIframe from 'vue-friendly-iframe'
// import '@/mock'
import store from './store'
import moment from 'moment'
import md5 from 'md5'
import 'moment/locale/es'
import printJS from 'print-js'
// import PouchDB from 'pouchdb'
import { sync } from 'vuex-router-sync'
import { AUTH_LOGOUT } from './store/actions/auth'
// import 'ant-design-vue/dist/antd.less'
import VueTheMask from 'vue-the-mask'

import '../static/less/variables.less'

import api from './utils/api.js' // Import Ant Design Vue styles by less entry
import common from './utils/common.js'
import generarExcel from './utils/generar_excel.js'
// import Vue2TouchEvents from 'vue2-touch-events'
import AwesomeIcon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/envelope'

import VueKonva from 'vue-konva'

import VueCountdown from '@chenfengyuan/vue-countdown'

Vue.component(VueCountdown.name, VueCountdown)

Vue.component('v-icon', AwesomeIcon)

sync(store, router)

Vue.prototype.$usuario = () => {
  return store.getters.usuario
}

// IMPORT DE COMPONENTES
// Vue.use(Button)
Vue.use(Vue2Editor)
Vue.use(VueAnalytics, {
  id: 'UA-171139174-2',
  checkDuplicatedScript: true,
  router
})
// Vue.use(Vue2TouchEvents)

Vue.prototype.$localeTabla = {
  emptyText: 'Sin Datos'
}

Vue.prototype.$md5 = md5
Vue.prototype.$moment = moment
Vue.prototype.$moment.locale('es')

Vue.prototype.$printJS = printJS

Vue.prototype.$localesDate = {
  lang: {
    placeholder: 'Seleccionar Fecha',
    rangePlaceholder: ['Fecha inicial', 'Fecha Final'],
    today: 'Hoy',
    now: 'Ahora',
    backToToday: 'Volver a Hoy',
    ok: 'Ok',
    clear: 'Limpiar',
    month: 'Mes',
    year: 'Año',
    timeSelect: 'Seleccionar Hora',
    dateSelect: 'Seleccionar Fecha',
    monthSelect: 'Elija un Mes',
    yearSelect: 'Elija un Año',
    decadeSelect: 'Elija una Década',
    yearFormat: 'YYYY',
    dateFormat: 'DD/MM/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
    previousMonth: 'Mes Anterior (PageUp)',
    nextMonth: 'Mes Siguiente (PageDown)',
    previousYear: 'Último año (Control + left)',
    nextYear: 'Año Siguiente (Control + right)',
    previousDecade: 'Última Década',
    nextDecade: 'Década Siguiente',
    previousCentury: 'Último siglo',
    nextCentury: 'Siguiente siglo'
  },
  timePickerLocale: {
    placeholder: 'Seleccionar hora'
  }
}

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(Viser)
Vue.use(Affix)
Vue.use(Upload)
Vue.use(Steps)
Vue.use(Tooltip)
Vue.use(Button)
Vue.use(BackTop)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Input)
Vue.use(Alert)
Vue.use(Layout)
Vue.use(Dropdown)
Vue.use(Avatar)
Vue.use(Menu)
Vue.use(Table)
Vue.use(Card)
Vue.use(Tag)
Vue.use(Spin)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popconfirm)
Vue.use(Switch)
Vue.use(Popover)
Vue.use(Select)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Drawer)
Vue.use(Divider)
Vue.use(Collapse)
Vue.use(Modal)
Vue.use(List)
Vue.use(Radio)
Vue.use(Badge)
Vue.use(FormModel)
Vue.use(Descriptions)
Vue.use(Slider)
Vue.use(Statistic)

Vue.use(VueTheMask)

Vue.use(VueKonva)

Vue.prototype.$message = message

Vue.prototype.$api = api
Vue.prototype.$common = common
Vue.prototype.$generarExcel = generarExcel

api.setToLoginPage(() => {
  store.dispatch(AUTH_LOGOUT).then(() => {
    this.a.$router.replace('/login')
    this.a.$message({
      message: 'Sesión caducada. Vuelva a loguearse.',
      type: 'info'
    })
  })
})
router.beforeEach((to, from, next) => {
  api.doCancelStack()
  next()
})
const permisos = [
  {
    nombre: 'Inicio',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Comprar Cartones',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Mis Cartones',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Comprar Creditos',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Usar Creditos',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Cartones Gratis',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Retirar Creditos',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Jugar En Vivo',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Resultado',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR', 'CLIENTE']
  },
  {
    nombre: 'Jugá a la Ruleta',
    roles: ['SUPERADMINISTRADOR', 'ADMINISTRADOR']
  }
]
//
/* eslint-disable */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    /*
    var db = new PouchDB('admindb')
    db.get('currUser').then(doc => {
      this.$store.commit('account/setuser', doc.user)
    })
    */
  },
  watch: {
    $route (to, from) {
      let nombreTo = to.name
      if (this.$store.getters.roles) {
        if (nombreTo !== 'Login' && nombreTo !== 'Registro'  && nombreTo !== 'Resultado Externo'  && nombreTo !== 'Recuperar Clave'  && nombreTo !== 'Restaurar Clave') {
          let keyArr = permisos.findIndex(
            permiso => permiso.nombre === nombreTo
          )
          var b = 0
          this.$store.getters.roles.forEach(element => {
            if (permisos[keyArr].roles.includes(element.nombre)) {
              b = 1
            }
          })
          if (!b) {
            this.$message.error(
              'Debe iniciar sesión para ingresar a esta sección'
            )
            this.$store.dispatch(AUTH_LOGOUT).then(this.$router.push('/'+'?redir='+to.path))
          }
        }
      } else {
        if (nombreTo !== 'Login' && nombreTo !== 'Registro'  && nombreTo !== 'Resultado Externo'  && nombreTo !== 'Recuperar Clave'  && nombreTo !== 'Restaurar Clave') {
          this.$message.error(
            'Debe iniciar sesión para ingresar a esta sección'
          )
          this.$store.dispatch(AUTH_LOGOUT).then(this.$router.push('/'+'?redir='+to.path))
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js